var render, staticRenderFns
import script from "./ChartPortfolioVulnerabilities.vue?vue&type=script&lang=js&"
export * from "./ChartPortfolioVulnerabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ae97ab')) {
      api.createRecord('31ae97ab', component.options)
    } else {
      api.reload('31ae97ab', component.options)
    }
    
  }
}
component.options.__file = "src/views/dashboard/ChartPortfolioVulnerabilities.vue"
export default component.exports